
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameSlug]/articles/[articleCategorySlug]/[articleSlug]",
      function () {
        return require("private-next-pages/[gameSlug]/articles/[articleCategorySlug]/[articleSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameSlug]/articles/[articleCategorySlug]/[articleSlug]"])
      });
    }
  